import { render, staticRenderFns } from "./mould.vue?vue&type=template&id=23ea21d8&scoped=true"
import script from "./mould.vue?vue&type=script&lang=js"
export * from "./mould.vue?vue&type=script&lang=js"
import style0 from "./mould.vue?vue&type=style&index=0&id=23ea21d8&scoped=true&lang=scss"
import style1 from "./mould.vue?vue&type=style&index=1&id=23ea21d8&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea21d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ea21d8')) {
      api.createRecord('23ea21d8', component.options)
    } else {
      api.reload('23ea21d8', component.options)
    }
    module.hot.accept("./mould.vue?vue&type=template&id=23ea21d8&scoped=true", function () {
      api.rerender('23ea21d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ScratchJr/mould.vue"
export default component.exports